import React from 'react';
import './CTASection.css';

interface CTASectionProps {
  onTryFree?: () => void;
}

const CTASection: React.FC<CTASectionProps> = ({ onTryFree }) => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <h2 className="cta-title">Transforme Seu Texto em Conteúdo Natural e Profissional</h2>
        <p className="cta-description">
          Aprimore conteúdo gerado por IA em escrita clara, natural e autêntica. Seja do
          ChatGPT ou outra ferramenta, o Humanizador ajuda você a criar textos de alta qualidade com estilo humano em apenas um clique.
        </p>
        <button className="cta-button" onClick={onTryFree}>Comece grátis</button>
        <p className="cta-note">500 palavras grátis. Não é necessário cartão de crédito</p>
      </div>
    </section>
  );
};

export default CTASection;